<template>
  <div class="confetti-confidence">
    <meter
      class="confidence-indicator"
      min="0"
      max="100"
      :low="highConfidenceThreshold"
      optimum="100"
      :value="scorePercentage"
    >
      {{ scorePercentage }}%
    </meter>
  </div>
</template>

<script>
export default {
  name: "ConfettiConfidence",
  props: {
    score: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      highConfidenceThreshold: 90,
    };
  },
  computed: {
    scorePercentage() {
      const score = this.score || 0;
      const scorePercentage = score * 100;

      return scorePercentage;
    },
  },
};
</script>

<style lang="scss" scoped>
/* stylelint-disable no-descending-specificity */

@import "confetti/scss/variables/colors";

$confidence-height: 0.5rem;

.confidence-indicator {
  background: $confidence-background;
  block-size: $confidence-height;
  border-radius: $confidence-height;
  display: block;
  inline-size: 100%;

  &::-webkit-meter-bar {
    background: $confidence-background;
    block-size: $confidence-height;
    border: 0;
    border-radius: $confidence-height;
  }

  &:-moz-meter-bar {
    background: $confidence-background;
    border-radius: $confidence-height;
  }

  &::-webkit-meter-optimum-value {
    background: $confidence-high;
    border-radius: $confidence-height;
  }

  &:-moz-meter-optimum::-moz-meter-bar {
    background: $confidence-high;
    border-radius: $confidence-height;
  }

  &::-webkit-meter-suboptimum-value {
    background: $confidence-low;
    border-radius: $confidence-height;
  }

  &:-moz-meter-sub-optimum::-moz-meter-bar {
    background: $confidence-low;
    border-radius: $confidence-height;
  }
}
</style>
